import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/home';

export default function HotArticles() {
  return (
    <section id="hot-articles" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-10">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              今日热门瓜田
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              精选全网最火的网红反差与明星爆料
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop="">
            {hotArticles.map((article, index) => (
              <Link
                key={article.id}
                to="/category/all"
                className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:ring-2 hover:ring-primary-200"
              >
                {/* Image */}
                <div className="relative w-full h-52 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                      {article.tag}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-5">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-xs md:text-sm mb-4 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{article.views} 阅读</span>
                    <span className="text-xs text-foreground-400">{article.date}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* View More */}
          <div className="mt-10 text-center">
            <Link
              to="/category/influencer-scandal"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 font-medium text-sm whitespace-nowrap hover:border-primary-500 hover:text-primary-500 transition-colors duration-200"
            >
              查看更多爆料
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}